import axios from '../../Util/AxiosIntercepted';

export default class TrailPublisher {
    constructor(user, roommateIds, roomId, uniqueDrawingId) {
        this.user = user;
        this.roommateIds = roommateIds;
        this.points = [];
        this.TERMINAL_POINT = { terminal: true };
        this.roomId = roomId;
        // this allows showing cursor if same user logged into the same room from different browsers 🙄
        this.uniqueDrawingId = uniqueDrawingId;
    }

    // Point at a new set of recipients without disturbing the buffer. Canvas
    // re-renders often - roommateIds is rebuilt from scratch on every room
    // event - and building a fresh publisher each time would throw away
    // whatever has been drawn since the last flush.
    retarget(user, roommateIds, roomId) {
        this.user = user;
        this.roommateIds = roommateIds;
        this.roomId = roomId;
    }

    addPoint(pt) {
        this.points.push(pt);
    }

    async flushIntermediate() {
        await this.emit();
    }

    async pointsDone() {
        this.points.push({ ...this.TERMINAL_POINT, t: Date.now() });
        await this.emit();
    }

    async emit() {
        // Snapshot and clear immediately so concurrent calls don't double-send
        const toSend = this.points;
        this.points = [];
        if (toSend.length === 0) return;
        await axios
            .post(`/events/path`, {
                user: { userId: this.user.userId },
                roommateIds: this.roommateIds.filter((x) => x != this.user.userId),
                points: toSend,
                roomId: this.roomId,
                uniqueDrawingId: this.uniqueDrawingId
            })
            .catch(console.error);
    }
}
